import { storage } from '@/config'
import Cookies from 'js-cookie'

export function getStudents() {
  let keyName = 'students'
  let keyValue = ''
  if ('localStorage' === storage) {
    keyValue = localStorage.getItem(keyName)
  } else if ('sessionStorage' === storage) {
    keyValue = sessionStorage.getItem(keyName)
  } else if ('cookie' === storage) {
    keyValue = Cookies.get(keyName)
  } else {
    keyValue = localStorage.getItem(keyName)
  }
  if (!keyValue) keyValue = '[]'
  return JSON.parse(keyValue)
}

export function getStudent(id) {
  let keyName = 'students'
  let keyValue = '[]'
  if ('localStorage' === storage) {
    keyValue = localStorage.getItem(keyName)
  } else if ('sessionStorage' === storage) {
    keyValue = sessionStorage.getItem(keyName)
  } else if ('cookie' === storage) {
    keyValue = Cookies.get(keyName)
  } else {
    keyValue = localStorage.getItem(keyName)
  }
  let students = JSON.parse(keyValue)
  let student = {}
  for (var i = 0; i < students.length; i++) {
    if (students[i].Id == id) {
      student = students[i]
    }
  }
  return student
}

export function setStudents(students) {
  let keyName = 'students'
  let keyValue = JSON.stringify(students)
  if ('localStorage' === storage) {
    return localStorage.setItem(keyName, keyValue)
  } else if ('sessionStorage' === storage) {
    return sessionStorage.setItem(keyName, keyValue)
  } else if ('cookie' === storage) {
    return Cookies.set(keyName, keyValue)
  } else {
    return localStorage.setItem(keyName, keyValue)
  }
}

export function removeStudents() {
  let keyName = 'students'
  if ('localStorage' === storage) {
    return localStorage.removeItem(keyName)
  } else if ('sessionStorage' === storage) {
    return sessionStorage.clear()
  } else if ('cookie' === storage) {
    return Cookies.remove(keyName)
  } else {
    return localStorage.removeItem(keyName)
  }
}
